export const PHYSICIAN_LIST = [
    {
        physicianId: '1-1L1JV-3041',
        hcpId: '91839019',
        firstName: 'Simon',
        lastName: 'Andrews',
        city: 'Morganton',
        state: 'NC',
        specialty: 'Orthopaedic Surgery',
        isFavorite: true,
    },
    {
        physicianId: '1-1L1JV-3041',
        hcpId: '91839019',
        firstName: 'Johnson',
        lastName: 'Brown',
        city: 'Morganton',
        state: 'NC',
        specialty: 'Orthopaedic Surgery',
        isFavorite: true,
    },
    {
        physicianId: '1-1L1JV-3041',
        hcpId: '91839019',
        firstName: 'Michael',
        lastName: 'Adamas',
        city: 'Morganton',
        state: 'NC',
        specialty: 'Orthopaedic Surgery',
        isFavorite: true,
    },
    {
        physicianId: '1-1L1JV-3041',
        hcpId: '91839019',
        firstName: 'Brandon',
        lastName: 'Clark',
        city: 'Morganton',
        state: 'NC',
        specialty: 'Orthopaedic Surgery',
        isFavorite: true,
    },
    {
        physicianId: '1-1L1JV-3041',
        hcpId: '91839019',
        firstName: 'Brandon',
        lastName: 'Clark',
        city: 'Morganton',
        state: 'NC',
        specialty: 'Orthopaedic Surgery',
        isFavorite: true,
    },
    {
        physicianId: '1-1L1JV-3041',
        hcpId: '91839019',
        firstName: 'Brandon',
        lastName: 'Clark',
        city: 'Morganton',
        state: 'NC',
        specialty: 'Orthopaedic Surgery',
        isFavorite: true,
    },
    {
        physicianId: '1-1L1JV-3041',
        hcpId: '91839019',
        firstName: 'Brandon',
        lastName: 'Clark',
        city: 'Morganton',
        state: 'NC',
        specialty: 'Orthopaedic Surgery',
        isFavorite: true,
    },
];
